import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initTelemetry, TelemetryErrorBoundary } from '@cca/ui';
import { App } from './App';
import { initTheme } from './lib/theme';
// Shared design system (tokens + canonical component classes) before the app
// stylesheet; quota keeps its own base/body + night-mode token overrides.
import '@cca/ui/tokens';
import '@cca/ui/components';
import './styles/globals.css';

initTheme();

const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';
initTelemetry({ portal: 'model', endpoint: `${apiBase}/api/telemetry` });

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <TelemetryErrorBoundary>
      <App />
    </TelemetryErrorBoundary>
  </StrictMode>,
);
